import React from "react"
import PropTypes from "prop-types"
import BottomModal from '../app_components/BottomModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import dateTimeFormat from '../utils/dateTimeFormat'

class LexicoinHistory extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lexicoins: this.props.lexicoins,
      history: [],
    }

    this.renderHistory = this.renderHistory.bind(this)
  }

  componentDidMount() {
    //get history
    $.ajax({
      url: `../getLexicoinHistory`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          history: JSON.parse(data.data.lexicoin_records),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderHistory() {
    return this.state.history.map((history, i) => {
      const { increase, points, description, record_date } = history
      return(
        <div
          key={i}
          style={{
            borderBottom: '1px solid #D3D3D3',
            paddingTop: 10,
            paddingBottom: 10,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row'
          }}>
          <div style={{width: 40}}>
            {points != null &&
              <div
                style={{
                  border: `1px solid ${increase ? '#01579B' : '#FF7E47'}`,
                  borderRadius: 50,
                  padding: 7,
                  width: 32,
                  height: 32
                }}>
                <FontAwesomeIcon
                  icon={increase ? faArrowUp : faArrowDown}
                  className={increase ? "darkBlue" : "red"}
                  style={{fontSize: 18}}
                />
              </div>
            }
          </div>
          <h5 style={{width: 220}}>{description}</h5>
          <div style={{width: 80}}>
            {points != null &&  <h5
              className={increase ? "darkBlue" : "red"}
              style={{ fontWeight: '700', textAlign: 'right'}}>{increase ? "+" : "-"}{points} lexicoin{points === 1 ? '' : 's'}</h5>}
            <p style={{color: '#868686', textAlign: 'right', paddingTop: 5}}>{dateTimeFormat(record_date)}</p>
          </div>
        </div>
      )
    })
  }

  render() {
    return(
      <BottomModal onClose={this.props.onClose}>
        <div style={{margin: 'auto', marginTop: 0}}>
          <div className="lexicoinHistory"></div>
          <div style={{marginTop: -110, marginLeft: 180, textAlign: 'center', width: 150, height: 110}}>
            <h1 style={{color: '#fff', fontWeight: '700', fontSize: 50}}>{this.state.lexicoins}</h1>
            <h5 style={{color: '#fff', fontWeight: '700'}}>lexicoins</h5>
          </div>
          <h4 className="bold" style={{borderBottom: '1px solid #D3D3D3', paddingTop: 10, paddingBottom: 10}}>My Lexicoin History</h4>
          {this.renderHistory()}
        </div>
      </BottomModal>
    )
  }

}

export default LexicoinHistory;
